import type {
  ApiSuccess,
  CartSignalInput,
  InboxPage,
  InboxUnread,
  NotifyPrefs,
  NotifyPrefsInput,
  PushRegisterInput,
  PushRegisterResult,
} from '@capsico/contracts';
import { INBOX_PAGE_SIZE } from '@capsico/contracts';
import { api } from './client';

/* W18 notifications: inbox (system of record), preferences, push devices, cart signal. */

const BASE = '/v1/customer/me';

export async function fetchInbox(cursor: string | null): Promise<InboxPage> {
  const res = await api.get<ApiSuccess<InboxPage>>(`${BASE}/inbox`, {
    params: { limit: INBOX_PAGE_SIZE, ...(cursor ? { cursor } : {}) },
  });
  return res.data.data;
}

export async function fetchUnread(): Promise<InboxUnread> {
  const res = await api.get<ApiSuccess<InboxUnread>>(`${BASE}/inbox/unread`);
  return res.data.data;
}

/** Empty ids = mark everything read. Returns the new unread count. */
export async function markInboxRead(ids: string[]): Promise<InboxUnread> {
  const res = await api.post<ApiSuccess<InboxUnread>>(`${BASE}/inbox/read`, { ids });
  return res.data.data;
}

export async function fetchNotifyPrefs(): Promise<NotifyPrefs> {
  const res = await api.get<ApiSuccess<NotifyPrefs>>(`${BASE}/notify-prefs`);
  return res.data.data;
}

export async function saveNotifyPrefs(input: NotifyPrefsInput): Promise<NotifyPrefs> {
  const res = await api.put<ApiSuccess<NotifyPrefs>>(`${BASE}/notify-prefs`, input);
  return res.data.data;
}

export async function registerPushDevice(input: PushRegisterInput): Promise<PushRegisterResult> {
  const res = await api.post<ApiSuccess<PushRegisterResult>>(`${BASE}/push-devices`, input);
  return res.data.data;
}

export async function removePushDevice(token: string): Promise<void> {
  await api.post(`${BASE}/push-devices/remove`, { token });
}

export async function sendCartSignal(input: CartSignalInput): Promise<void> {
  await api.put(`${BASE}/cart-signal`, input);
}
